// extracted by mini-css-extract-plugin
export default {"notificationsZIndex":"14000","container":"_3BhCcUOJyY","label":"NqawdFj-jc","titleContainer":"_1APzoAYXbC"};